






















































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { TableStripe } from '@/mixins/tableStripe';
import PagingUnit from '@/components/paging/paging.vue';
import { institutionServer, patrolManagementServe, performanceServer, spaceServe } from '@/api/installServer';
import Add from '@/views/patrolManagement/patrolLine/unit/add.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { CollapseTransition, PagingUnit, Add },
  mixins: [TableStripe],
})
export default class PatrolLine extends Vue {
  private multipleSelection: any = []; // 批量操作数据

  private showFlag = 0;
  row: any = {};

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 1000; // 数据总共多少条

  treeData: Array<any> = []; // 树状图数据

  // 搜索表单数据
  formData: any = {
    name: '', // 巡检线路名称
  };
  // formShow = false; // 是否显示表单搜索
  // table数据
  tableData: any[] = [];
  // 执行部门
  subSpaceByAuthOptions: any = [];
  private loading = false;
  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  created() {
    this.getSubSpaceByAuth();
    this.getPatrolLineAllData();
  }

  private getPatrolLineAllData(): void {
    this.loading = true;
    patrolManagementServe
      .getPatrolLineAllData({
        paging: true,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        search: this.formData.name ? this.formData.name : null,
        deptId: this.formData.deptId ? this.formData.deptId : null,
      })
      .then((res: any) => {
        this.loading = false;
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getPatrolLineAllData();
  }

  addHandle() {
    this.row.id = '';
    this.showFlag = 1;
  }
  /**
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    this.getPatrolLineAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    // 获取全部数据
    this.getPatrolLineAllData();
  }

  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }

  /**
   * 【按钮】批量操作按钮指令
   */
  handleBatchCommand(command: string) {
    if (this.multipleSelection.length === 0) {
      this.$message.warning('请选择您要操作的数据。');
      return;
    }
    switch (command) {
      case 'remove':
        this.handleBatchRemove();
        break;
    }
  }

  /**
   * 批量删除
   */
  handleBatchRemove() {
    this.$confirm('此操作将永久删除, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        const _selectList = this.multipleSelection.map((item: any) => item.id);
        this.removeLineData(_selectList);
      })
      .catch(() => {});
  }

  /**
   * 【接口】删除标准卡
   * @param ids {String} 标准卡id
   */
  async removeLineData(ids: string | string[]) {
    try {
      const res: any = await patrolManagementServe.deletePatrolLine(ids);
      this.getPatrolLineAllData();
    } catch (e) {
      this.$message.warning('删除失败。');
      throw new Error();
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏和显示按钮触发，控制表单搜索内容是否显示
   * @param1 暂无
   * @returns 暂无
   */
  // setFormShow() {
  //   this.formShow = !this.formShow;
  // }

  editHandle(data: any) {
    this.row.id = data.id;
    this.showFlag = 1;
  }
  deleteHandle(data: any) {
    this.$confirm('此操作将永久删除该巡检线路, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.removeLineData(data.id);
        this.getPatrolLineAllData();
      })
      .catch(() => {});
  }

  responseHandle() {
    this.showFlag = 0;
    this.getPatrolLineAllData();
  }
}
